import styled from 'styled-components'

interface IBudgetTrackerCardStyledProps {}

export const BudgetTrackerCardStyled = styled.div<IBudgetTrackerCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
